import { sessionStorageKeys } from '@/reporting/sessionTrackingData';

export const allowedParams = [
  'clickToChat', // when true, opens Intercom chat
  'openFundbox', // when true, auto-opens Fundbox Fuse overlay on marketing page
  'referrer',
  'correlationId', // correlation id sent from a different application to be used in tracking
  // Auth deep-link params (excludes authToken/authorization/magicLoginToken — security-sensitive)
  'redirect',
  'id',
  'draftId',
  'draftSource', // SMB-to-enterprise handoff signal (e.g. 'smb')
  // MarketHistory deep-link params
  'creditNoteId',
  'download',
  'payDate',
  // FileDownloadModal deep-link params
  'downloadConsolidatedInvoice',
  'downloadConsolidatedTakerAward',
  'startDate',
  'endDate',
  'makerIds',
  'urlExpirationDate',
  ...sessionStorageKeys, // allowed UTM params
];

/**
 * filters URL search params to only include allowed parameters
 */
export const filterAllowedParams = (search: string) => {
  const params = new URLSearchParams(search);
  const filteredParams = new URLSearchParams();

  for (const [key, value] of params) {
    if (allowedParams.includes(key)) {
      filteredParams.set(key, value);
    }
  }

  return filteredParams.size > 0 ? `?${filteredParams.toString()}` : '';
};
